import {numbersAreMatched, isExtension} from "../../utils/phoneNumbers";
import {getColor} from "../../utils/colors";
import {fetchContacts} from "../../api/contacts";

export default {
    namespaced: true,
    state: {
        contacts: [],
        extensions: [],
        defaultContact: {
            name: '',
            number: '',
            callerid_id: '',
            phonebook_id: '',
            email: '',
            image: null,
            avatar: '',
            color: '',
            id: null,
            is_new: 1
        }
    },
    getters: {
        defaultContact: (state) => {
            return state.defaultContact;
        },
        contacts: (state) => {
            return state.contacts;
        },
        extensions: (state) => {
            return state.extensions
        },
        getContactByNumber: (state) => number => {
            let contact = state.contacts.find((contact) => {
                return numbersAreMatched(contact.number, number)
            })
            if (contact) {
                return contact
            }

            return  state.defaultContact
        },
        getContactsByNumber: (state) => number => {
            let contacts = state.contacts.filter(contact => numbersAreMatched(contact.number, number))
            if (contacts.length) {
                return contacts
            }

            return  [state.defaultContact]
        }
    },
    actions: {
        loadContacts: ({commit}) => {
            return new Promise((resolve, reject) => {
                fetchContacts()
                    .then(response => {
                        let extensions = []

                        response.data.forEach(function (item) {
                            item.is_new = 0;
                            item.color = getColor(item.name)
                            item.status = 'contact-unavailable'

                            if (item.is_linked_to_user) {
                                extensions.push(item.number)
                            }
                        })
                        commit('setContacts', response.data)
                        commit('setExtensions', extensions)
                        resolve(response.data)
                    })
                    .catch(() => reject())
            })
        }
    },
    mutations: {
        setContacts: (state, contacts) => {
            state.contacts = contacts;
        },
        setExtensions: (state, extensions) => {
            state.extensions = extensions
        }
    }
}